export default "__VITE_ASSET__DHI9D13x__"